import React from "react";
import PropTypes from "prop-types";
import ReactInterval from "react-interval";
// import material-ui components
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TablePagination from "@material-ui/core/TablePagination";
//import @material-ui/icons
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "components/Table/Table.jsx";
import UserDialog from "components/Dialogs/UserDialog";
import ConfirmDeleteDialog from "components/Dialogs/ConfirmDeleteDialog";
import SuccessDialog from "components/Dialogs/SuccessDialog";
import ErrorDialog from "components/Dialogs/ErrorDialog";

import usersStyle from "assets/jss/material-dashboard-react/views/usersStyle"

import * as actionCreators from "actions/users";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        isMasterOrganization: state.auth.isMasterOrganization,
        users: state.users,
        roles: state.users.roles,
        organizations: state.users.organizations,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class UsersView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            usersData: [],
            confirmDeleteUserDialogIsOpened: false,
            deleteUserId: null,
            userDialogIsOpened: false,
            userDialogIsNew: false,
            userDialogData: null,
            timeoutEnabled: false,
            usersRowsPerPage: 25,
            usersPage: 1,
            successDialogIsOpened: false,
            errorDialogIsOpened: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        const { classes } = this.props;
        this.setState((prevState) => ({
            ...prevState,
            usersData: nextProps.users.data.map((prop) => (
                [prop.id, prop.username, prop.email, prop.name, prop.role, prop.organization,
                    (prop.isActive ? <CheckBoxIcon/> : <CheckBoxBlankIcon/>),
                    (<div>
                        <Button justIcon round simple color="transparent"  className={classes.tableButton}
                                onClick={() => this.userDialogOpen(prop.id)}
                        >
                            <EditIcon/>
                        </Button>
                        <Button justIcon round simple color="danger"  className={classes.tableButton}
                                onClick={() => this.deleteUserDialogOpen(prop.id)}
                        >
                            <DeleteIcon/>
                        </Button>
                    </div>)]
            ))
        }))
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true
        });
        this.getData()
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }

    getData(){
        this.props.getUsers(this.props.token, this.state.usersPage, this.state.usersRowsPerPage);
        this.props.getRoles(this.props.token);
        this.props.getUsersOrganizations(this.props.token);
    }

    deleteUserDialogOpen(id){
        this.setState({
            confirmDeleteUserDialogIsOpened: true,
            deleteUserId: id
        })
    }

    deleteUserDialogClose(){
        this.setState({
            confirmDeleteUserDialogIsOpened: false,
        })
    }

    deleteUser(){
        this.deleteUserDialogClose();
        this.state.deleteUserId && this.props.delUser(this.props.token, this.state.deleteUserId)
            .then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()});
        this.setState({
            deleteUserId: null
        })
    }

    userDialogOpen(userId){
        this.setState({
            userDialogIsNew: !userId,
            userDialogIsOpened: true,
            userDialogData: userId && this.props.users.isLoaded ? this.props.users.data.map((user) => (user.id === userId ? user : null)).filter(n => n)[0] : null,
        })
    }

    userDialogClose(){
        this.setState({
            userDialogIsOpened: false,
            userDialogData: null,
        })
    }

    saveUser(user){
        this.userDialogClose();
        if (!this.state.userDialogIsNew) {
            this.props.editUser(this.props.token, user)
                .then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()});
        }else{
            this.props.createUser(this.props.token, user)
                .then(r => {typeof r !== typeof undefined ? this.successDialogShow(): this.errorDialogOpen()});
        }
        this.getData();
    }

    handleMachinesChangePage(page){
        this.setState({
            usersPage: page
        }, this.getData)
    }

    handleMachinesChangeRowsPerPage(e){
        if (e.target.value !== this.state.usersRowsPerPage) {
            this.setState({
                usersRowsPerPage: e.target.value
            }, this.getData);
        }
    }

    successDialogShow(){
        this.setState({
            successDialogIsOpened: true,
        })
    }

    successDialogClose(){
        this.setState({
            successDialogIsOpened: false,
        })
    }

    errorDialogOpen(){
        this.setState({
            errorDialogIsOpened: true,
        })
    }

    errorDialogClose(){
        this.setState({
            errorDialogIsOpened: false,
        })
    }

    render(){
        const { classes } = this.props;
        return (
            <div>
                <Card>
                    <CardHeader color="success">
                        <Grid container>
                            <GridItem xs={6} s={10} md={10}>
                                <h4>Пользователи</h4>
                            </GridItem>
                            <GridItem xs={6} s={2} md={2}>
                                <Button color="success" className={classes.headerButton} onClick={() => this.userDialogOpen()}>
                                    <AddIcon className={classes.icons}/>Новый
                                </Button>
                            </GridItem>
                        </Grid>
                    </CardHeader>
                    <CardBody>
                        <Table
                            tableHead={["ID", "Логин", "E-mail", "Имя", "Роль", "Организация", "Активная запись", ""]}
                            tableData={this.state.usersData}
                            tablePagination={(<TablePagination count={this.props.users.count || 0}
                                                           onChangePage={(e, page) => this.handleMachinesChangePage(page + 1)}
                                                           page={this.state.usersPage - 1} rowsPerPage={this.state.usersRowsPerPage}
                                                           labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                           labelRowsPerPage="Строк на страницу:" component="div"
                                                           onChangeRowsPerPage={(e) => this.handleMachinesChangeRowsPerPage(e)}
                            />)}
                        />
                        <ConfirmDeleteDialog isOpened={this.state.confirmDeleteUserDialogIsOpened}
                            onCancel={() => this.deleteUserDialogClose()} onSave={() => this.deleteUser()}
                            bodyText="Вы точно хотите удалить данного пользователя? Данное действие нельзя будет отменить."
                        />
                        <UserDialog isOpened={this.state.userDialogIsOpened} onCancel={() => this.userDialogClose()}
                                    onSave={(user) => this.saveUser(user)} userData={this.state.userDialogData}
                                    isNew={this.state.userDialogIsNew} roles={this.props.roles}
                                    organizations={this.props.organizations}
                                    organizationEditable={this.props.isMasterOrganization}
                        />
                    </CardBody>
                </Card>
                <SuccessDialog onClose={() => this.successDialogClose()} isOpened={this.state.successDialogIsOpened}/>
                <ErrorDialog onClose={() => this.errorDialogClose()} isOpened={this.state.errorDialogIsOpened}/>
                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
        )
    }
}

UsersView.propTypes = {
    getUsers: PropTypes.func,
    getRoles: PropTypes.func,
    editUser: PropTypes.func,
    onDel: PropTypes.func,
    onEdit: PropTypes.func,
    delUser: PropTypes.func,
    getUsersOrganizations: PropTypes.func,
    token: PropTypes.string,
    usersIsLoaded: PropTypes.bool,
    users: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
        count: PropTypes.number,
        pages: PropTypes.number,
        page: PropTypes.number,
    }),
    roles: PropTypes.arrayOf(PropTypes.string),
    createUser: PropTypes.func,
    organizations: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(usersStyle)(UsersView));


// WEBPACK FOOTER //
// ./src/views/Users/Users.jsx